import { MeUser } from "../../../../../services/models/me-user";
import { InterviewsService } from "../../../../../services/interviews.service";
import { ActionCol } from "../../../../../shared/table-col-configs/action-col";
import { Type } from "@angular/core";
import { DetailButtonComponent } from "../../../../../shared/table-components/detail-button/detail-button.component";
import { OpenDetailCommand } from "../../../../../shared/commands/open-detail-command";
import { TextCol } from "../../../../records/models/columns/text-col";
import { ActionButtonsComponent } from "../../../../../shared/table-components/action-buttons/action-buttons.component";
import { ActionButtonsNoTextComponent } from "../../../../../shared/table-components/action-buttons-no-text/action-buttons-no-text.component";
import { CreateRecoveryPlanCommand } from "../../../../../shared/commands/create-recovery-plan-command";
import { IQuestion } from "src/app/interface/filters";
import { InterviewsV2Service } from "src/app/services/interviews-v2.service";

export const INTERVIEW_SUMMARY_COLUMNS_DEFAULT = (user: MeUser, service: InterviewsService | InterviewsV2Service, question: IQuestion) =>
	[
		new ActionCol<any, Type<DetailButtonComponent<any>>, InterviewsService | InterviewsV2Service>(
			"surveyRequestId",
			true,
			undefined,
			[new OpenDetailCommand()],
			DetailButtonComponent
		),
		new TextCol("brand", false, undefined, undefined, true, false),
		new TextCol("dealer", false, undefined, undefined, false, false),
		new TextCol("dealerName",false,undefined,undefined,true,undefined,undefined,true),
		new TextCol("market"),
		new TextCol("vin", true),
		new TextCol("customerName",true,undefined,undefined,undefined,undefined,undefined,true),
		new TextCol("interviewdate"),
		new TextCol("dataSurvey"),
		new TextCol("dealerGroup"),
		new TextCol("engine", undefined, undefined, undefined, true),
		new TextCol("model"),
		// new TextCol("rpStatus"),
		new TextCol("rpDtStatus"),
		new ActionCol<any, Type<ActionButtonsComponent<any>>, InterviewsService | InterviewsV2Service>(
			"rpCreateBtn",
			false,
			"hotAlertTable.rpStatus",
			[new CreateRecoveryPlanCommand<any, InterviewsService | InterviewsV2Service>(service)],
			ActionButtonsNoTextComponent
		),
	]